import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchBooks, searchPages } from '../actions';

function SearchBar(props) {
  const [query, setQuery] = useState('');

  const keyUp = (e) => {
    if (e.key === 'Enter') {
      console.log('searching (i should be)!');
      props.searchPages(query);
      props.history.push(`/search/${query}`);
    }
  };

  useEffect(() => {
    if (props.match.params.query) setQuery(props.match.params.query);
  }, []);

  return (
    <div className="search-bar">
      <input onKeyUp={keyUp} onChange={(e) => setQuery(e.target.value)} value={query} placeholder="Search our library..." />
    </div>
  );
}

export default withRouter(connect(null, { fetchBooks, searchPages })(SearchBar));
